import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Loader } from 'lucide-react';
import { adminApi } from '../../api/client';
import { useLanguage } from '../../context/LanguageContext';
import TranslatorProfileView from '../../components/dashboard/TranslatorProfileView';
import './AdminHome.css';
import './AdminTranslatorProfilePage.css';

export default function AdminTranslatorProfilePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useLanguage();
  const a = t.dashboard?.admin || {};
  const [user, setUser] = useState(null);
  const [busy, setBusy] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!id) return;
    setBusy(true);
    adminApi.getTranslator(id)
      .then((res) => setUser(res.translator))
      .catch(() => setError(a.notFound || 'Traducteur non trouvé'))
      .finally(() => setBusy(false));
  }, [id, a]);

  if (busy) {
    return (
      <div className="atp-page">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, color: 'var(--dash-muted)' }}>
          <Loader size={22} className="spin" />
          <span>Chargement du profil…</span>
        </div>
      </div>
    );
  }

  if (error || !user) {
    return (
      <div className="atp-page">
        <button type="button" className="atp-back" aria-label={a.back || 'Retour'} onClick={() => navigate('/admin/translators')}>
          <ArrowLeft size={20} />
        </button>
        <div className="atp-card">
          <p>{error || a.notFound || 'Traducteur non trouvé'}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="atp-page">
      <button type="button" className="atp-back" aria-label={a.back || 'Retour'} onClick={() => navigate('/admin/translators')}>
        <ArrowLeft size={20} />
      </button>
      <div className="atp-card">
        <TranslatorProfileView user={user} />
      </div>
    </div>
  );
}
